// extracted by mini-css-extract-plugin
module.exports = {"input_border":"#F0F0F8","list_added":"styles_list_added__1xc4J","list_del":"styles_list_del__3vdgi"};